import Para from "@/atoms/text/Para";
import Image from "@/atoms/Image";

export default function Tile({
  bgColor,
  href,
  logo,
  icon,
  title,
  content,
  badge,
  isLargeTile,
  isLearnMore,
  hasTileTop,
  hasBorder = false,
  isTileClickable = true,
  className,
  ...props
}) {
  const fileName = logo?.fileName || "";
  const desktopWidth = logo?.desktopWidth || 84;

  return (
    <div
      className={`ps-r bc-${bgColor} ${className} ta-center ${
        isLargeTile
          ? `tile--md ${hasBorder ? "tile--md__solid" : ""}`
          : isTileClickable
          ? "tile--sm"
          : "tile--static"
      } ${hasTileTop ? "tile-top tile-top--org" : ""}`}
    >
      {badge && badge}
      {isTileClickable && <a href={href} className="full" {...props} />}
      {icon && icon}
      {logo && (
        <Image
          fileName={fileName}
          isBannerImg={false}
          fileFormat="png"
          desktopWidth={desktopWidth}
          alt={title}
          className="fx fx--ch mb-3"
        />
      )}
      <Para
        desktopSize="lg"
        mobileSize="lg"
        className="text--mont heading mb-1 bold"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <div className="content-wrapper m-center">
        <Para
          mobileSize="md"
          dangerouslySetInnerHTML={{ __html: content }}
          className={`${isLearnMore ? "mb-5" : ""}`}
        />
      </div>

      {isLearnMore && (
        <a href="#" className="btn btn--link btn--link-lg text--md">
          Learn more
        </a>
      )}
      <style jsx>{`
        .tile--sm .content-wrapper {
          max-width: 228px;
        }
        @media (max-width: 580px) {
          .tile--sm .content-wrapper {
            max-width: 236px;
          }
        }
      `}</style>
    </div>
  );
}

Tile.defaultProps = {
  bgColor: "white",
  href: "#",
  isLargeTile: false,
  className: "",
};
